import { LOGO_URL } from '@constants/Validation';
import { Trans } from '@lingui/macro';
import { Box, Button, Typography } from '@material-ui/core';
import { useAuth } from '@swyft/auth';
import { colors } from '@swyft/ui';
import React from 'react';

export const SuspendedErrorPage = () => {
  const { signOut } = useAuth();

  return (
    <Box width='100vw' height='100vh' className='flex justify-center items-center bg-white'>
      <Box width={{ xs: 400, md: 500 }} className='shadow-xl p-16 border rounded'>
        <img src={LOGO_URL} alt='logo-pipelyne' className='mx-auto h-12' />
        <Typography variant='h5' className='text-center my-6'>
          <Trans>This account is inactive</Trans>
        </Typography>
        <Typography variant='subtitle2' className='text-center'>
          <Trans>
            This account is no longer active
            <br />
            To reactivate this account, please contact
            <br />
          </Trans>
          <a href='mailto:support@swyfttechnology.ie' style={{ color: colors.primary.main }} className='font-bold'>
            support@swyfttechnology.ie
          </a>
        </Typography>
        <Button
          color='primary'
          variant='contained'
          className='normal-case font-normal w-40 h-12 shadow-none my-8 block mx-auto'
          onClick={signOut}
        >
          <Trans>Close</Trans>
        </Button>
      </Box>
    </Box>
  );
};
